module.exports = __webpack_public_path__ + "img/WaterYouDoingLogo_1920x1200.c3583125.png";